import { useEffect } from "react";

export default function useOrientationTracker(setVertical: SetBoolean) {
  useEffect(() => {
    const updateOrientation = () => {
      setVertical(window.innerHeight > window.innerWidth);
    };

    updateOrientation();

    window.addEventListener("resize", updateOrientation);

    return () => window.removeEventListener("resize", updateOrientation);
  }, [setVertical]);
}
